<template>
    <div>
        <!-- <img v-if="$store.state.formSuccess" :src="$store.state.formSuccess && $store.state.argann != '' ? `https://action.metaffiliation.com/trk.php?mclic=${ pixel }&argann=${ $store.state.argann }&altid=${ $store.state.altid }` : ''" width="1" height="1" border="0"/> -->
        <img height="1" width="1" style="display: none;" src="https://www.facebook.com/tr?id=1466652996976886&ev=Lead&noscript=1"/>
    </div>
</template>

<script>
export default {
    name: 'Pixel',
    data() {
        return {
            pixel: process.env.VUE_APP_MCLIC,
        };
    },
    mounted() {
        KWKUniJS.conversion({
            mclic: this.pixel,
            argann: this.$store.state.argann,
            altid: this.$store.state.altid,
        });
    },
};
</script>

<style>

</style>
